import Button from "@material-ui/core/es/Button/Button";
import GoogleMapReact from "google-map-react";
import * as moment from "moment";
import * as Pikaday from "pikaday";
import React from "react";
import Magnifier from "react-magnifier";
import { Link } from "react-router-component";
import { TwitterTimelineEmbed } from "react-twitter-embed";
import { SegmentedControl } from "segmented-control";
import AlertDialog from "../components/AlertDialog";
import { IconButton } from "../components/IconButton";
import Marker from "../components/Marker";
import PopupImage from "../components/PopupImage";
import VLButton from "../components/VLButton";
import * as Constants from "../Constants";
import * as API from "../util/api";
import * as Render from "../util/Render";
import * as Util from "../util/util";
import * as Variant from "../util/variant";
import PopupPowerGraph from "./PopupPowerGraph";
import PopupStatsGraph from "./PopupStatsGraph";
import VLScreen from "./VLScreen";

class CameraScreen extends VLScreen {

    constructor() {
        super();
        this.mapRef = React.createRef();
        this.historicDateInput = React.createRef();
        this.state = {
            loaded: false,
            groups: [],
            sensor_image: "",
            sensor_name: "",
            viewing_head: 0,
            viewingUrl: "",
            twitter_name: "EnvAgencyMids",
            sensor_images: [],
            editingText: false,
            showRequestEnhanced: false,
            showPowerGraph: false,
            editOpen: false,
            showRequestImage: false,
            viewing_map: 2,
            notes: [],
            new_note: "",
            showArchived: false,
            imageAspectRatio: "16:9",
            lastCheckedImage: null
        };
    }

    componentDidMount() {
        let dom = this;
        new Pikaday({
            field: this.historicDateInput.current,
            format: "DD/MM/YY",

            onSelect: function (date) {
                let event = {
                    target: {
                        name: "historic_date",
                        value: (date).getTime() / 1000
                    }
                };
                dom.handleInputChange(event);
            }
        });

        Util.getLocation(pos => {
            this.setState({ lat: pos.coords.latitude, lng: pos.coords.longitude });
        });

        this.setState({ viewing_head: this.props.defaultHead || 0 });
        this.load();
        this.timer = setInterval(() => {
            this.setState({ rn: Util.rn() });
        }, 1000);

        this.timer2 = setInterval(() => {
            if (this.state.update < this.minsSinceUpdate()) {
                this.doLoad();
            }
        }, 30 * 1000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        clearInterval(this.timer2);
    }

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if (prevProps.id != this.props.id) {
    //         this.load();
    //     }
    // }

    componentDidUpdate(prevProps, prevState) {
    const newImg = this.showingImage();
    const oldImg = this.state.lastCheckedImage;

    // if (this.props.id !== prevProps.id || this.state.viewing_head !== prevState.viewing_head) {
    //     this.load();
    // }

    if (this.props.id !== prevProps.id) {
        this.load();
    }

    if (newImg && newImg !== oldImg) {
        this.setState({ lastCheckedImage: newImg }, () => {
            this.detectAspectRatio(newImg);
        });
    }
}


    load = () => {
        this.setState({ loaded: false });
        this.doLoad();
    };

    doLoad = () => {
        let loaded = result => {
            Util.handleLogout(result);
            if (result.success) {
                let sensor = result.result.sensors[0];

                if (sensor.twitter_feed) {
                    sensor.twitter_name = sensor.twitter_feed;
                }
                this.setState(sensor);
                this.setState({ groups: result.result.groups });

                if (sensor.outstation_type == 3) {
                    this.setState({ hiRes: true });
                }
                if (sensor.variant == Variant.GAUGE) {
                    this.props.navigate("/sensor/" + sensor.sensor_id);
                    return;
                }

                Util.logHistory(sensor.sensor_name, "/camera/" + sensor.sensor_id);

                if (this.map) {
                    try {
                        this.map.panTo({ lat: sensor.sensor_lat, lng: sensor.sensor_long });
                    } catch (e) {
                    }
                }

                this.requireImage(sensor.sensor_image, () => this.setState({ loaded: true, error: null }));
            } else {
                console.log("ERROR " + result.error);
                console.log(result);
                this.setState({ error: result.error, loaded: true });
            }
        };
        if (Util.isCommunity()) {
            API.POST("systems/communityList", { sensor_id: this.props.id }, loaded);
        } else {
            API.POST("systems/list", { sensor_id: this.props.id, show_ea: false, show_nrw: false, show_floods: false }, loaded);
        }
    };

    requestText = () => {
        return <p>Requesting an image incurs a cost. Only continue if required for incident response. If not urgent,
            please wait for the next image.<br /><br />The next image will be available at {this.nextUpdateTime()}</p>;
    };

    doRequestImage = (confirm) => {
        this.setState({ showRequestImage: false });
        if (confirm) {
            API.POST("systems/requestImage", { sensor_id: this.state.sensor_id }, result => {
                if (result.success) {
                    this.showTextAlert("", "Image has been requested");
                } else {
                    this.basicAlert(result.error);
                }
            });
        }
    };

    enhancedText = () => {
        return <p>Requesting an enhanced poll incurs a cost. Only continue if required for incident response.</p>;
    };

    doRequestEnhanced = (confirm) => {
        this.setState({ showRequestEnhanced: false });
        if (confirm) {
            API.POST("systems/requestEnhancedPoll", { sensor_id: this.state.sensor_id }, result => {
                if (result.success) {
                    this.showTextAlert("", "Enhanced Poll has been requested");
                } else {
                    this.basicAlert(result.error);
                }
            });
        }
    };

    textEditor = () => {
        return <div>
            <textarea style={{ width: "100%", height: 500, maxHeight: "calc(100vh - 300px)" }}
                value={this.state.new_system_text} name="new_system_text" onChange={this.handleInputChange}
                className="vl-input" />
        </div>;
    };

    saveText = (doSave) => {
        if (doSave) {
            this.setState({ loaded: false });
            API.POST("systems/setText", { sensor_id: this.state.sensor_id, text: this.state.new_system_text }, result => {
                if (result.success) {
                    this.load();
                } else {
                    this.setState({ loaded: true });
                    this.basicAlert(result.error);
                }
            });
        }
        this.setState({ editingText: false, editOpen: false });
    };


    content() {
        const { imageAspectRatio } = this.state;

        let leftFlex = 22.5, middleFlex = 55, rightFlex = 22.5;
        if (imageAspectRatio === "4:3") {
            leftFlex = 27.5;
            middleFlex = 45;
            rightFlex = 27.5;
        } else if (imageAspectRatio === "16:9") {
            leftFlex = 22.5;
            middleFlex = 55;
            rightFlex = 22.5;
        } else {
            // fallback for uncommon ratios like square or 3:2
            leftFlex = 30;
            middleFlex = 40;
            rightFlex = 35;
        }

        return (
            <div style={{ display: "flex" }}>
                <div style={{ flex: leftFlex }}>
                    {this.renderInfo()}
                    {this.renderButtons()}
                    {this.renderText()}
                </div>
                <div style={{ flex: middleFlex, textAlign: "left", paddingLeft: 16, paddingRight: 16 }}>
                    {this.renderImageColumn()}
                </div>
                <div style={{ flex: rightFlex, display: "flex", flexDirection: "column", height: "calc(100vh - 120px)" }}>
                    {this.renderMapColumn()}
                </div>
                {this.state.viewingUrl && (
                    <PopupImage url={this.state.viewingUrl} close={() => this.setState({ viewingUrl: "" })} />
                )}
                {this.renderExtras()}
            </div>
        );
    }

    renderExtras = () => {
        return <div>
            {this.state.viewing_stats &&
                <PopupStatsGraph camera_id={this.state.sensor_id} navigate={this.props.navigate} close={() => {
                    this.setState({ viewing_stats: false });
                }} />
            }
            {this.renderTextAlert()}
            <AlertDialog title="Edit" open={this.state.editOpen} content={this.editAlert} />
            <AlertDialog title="Request Image" open={this.state.showRequestImage} content={this.requestText}
                positive="Request Now" negative="Cancel" action={this.doRequestImage} />
            <AlertDialog title="Request Enhanced Poll" open={this.state.showRequestEnhanced}
                content={this.enhancedText}
                positive="Request Now" negative="Cancel" action={this.doRequestEnhanced} />

            <AlertDialog title="Camera Text" positive="Save" negative="Cancel" content={this.textEditor}
                action={this.saveText}
                open={this.state.editingText} />

            {this.state.showPowerGraph && <PopupPowerGraph camera_id={this.state.sensor_id} navigate={this.props.navigate} close={() => {
                this.setState({ showPowerGraph: false });
            }} />}
        </div>;
    };


    title = () => {
        if (this.state.variant == Variant.IP_CAMERA) {
            return "IP Camera Details - " + this.state.sensor_name;
        } else if (this.state.variant == Variant.CAMERA) {
            return "GSM Camera Details - " + this.state.sensor_name;
        }
        return "Loading";
    };

    editAlert = () => {
        let id = this.state.sensor_id;
        return <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "stretch" }}>
            <Button color="primary" component={Link} href={"/edit/" + id}>Edit Camera Details</Button>
            <Button color="primary" component={Link} href={"/inputs/" + id}>Edit Camera Inputs</Button>
            <Button color="primary" onClick={() => this.setState({ editingText: true })}>
                Edit Camera Text
            </Button>
            <Button color="primary" onClick={() => this.setState({ editOpen: false })}>Cancel</Button>
        </div>;
    };

    minsSinceUpdate = () => {
        let secondsSinceUpdate = this.state.rn - this.state.sensor_comms_unix;
        let minsSinceUpdate = parseInt(secondsSinceUpdate / 60)
        // console.log("sUP " + minsSinceUpdate);
        if (isNaN(minsSinceUpdate)) {
            return "";
        }
        if (minsSinceUpdate >= 120) {
            minsSinceUpdate = "More than 2 hours ago"
        } else {
            minsSinceUpdate = minsSinceUpdate + " mins ago"
        }
        return minsSinceUpdate;
    };

    minsUntilUpdate = () => {
        let secondsSinceUpdate = this.state.rn - this.state.sensor_comms_unix;
        let minsSinceUpdate = parseInt(secondsSinceUpdate / 60);
        // console.log("Up " + minsSinceUpdate);
        if (isNaN(minsSinceUpdate)) {
            return "";
        }
        let minsUntilUpdate = this.state.update - minsSinceUpdate;
        if (minsUntilUpdate < 0) {
            minsUntilUpdate = "Pending update"
        } else {
            minsUntilUpdate = minsUntilUpdate + " mins remaining"
        }
        return minsUntilUpdate;
    }

    lastUpdateText = () => {
        let head = this.state.sensor_images[this.state.viewing_head];
        if (head != null) {
            const isOld = (Util.rn() - head.unix) > 24 * 60 * 60;
            return <p style={{ flex: 40, textAlign: "left", color: isOld ? "#f00" : "#000" }}>Last Update: {head.date}</p>;
        }
        return <p style={{ flex: 40, textAlign: "left" }}>Last Update: {this.state.sensor_comms}</p>;
    };
    detectAspectRatio = (src) => {
        if (!src) return;

        const img = new Image();
        img.onload = () => {
            const ratio = img.width / img.height;
            // console.log( img.width, img.height, ratio);
            let aspect;
            if (ratio > 1.72 && ratio < 1.79) {
                aspect = "16:9";
            } else if (ratio > 1.30 && ratio < 1.36) {
                aspect = "4:3";
            } else {
                aspect = "other";
            }

            // console.log(`Detected ratio: ${ratio.toFixed(3)} → ${aspect}`);
            this.setState({ imageAspectRatio: aspect });
        };

        img.src = src + "?_=" + new Date().getTime();
    };



    renderImageColumn = () => {
        let minsSinceUpdate = this.minsSinceUpdate();
        let minsUntilUpdate = this.minsUntilUpdate();
        
        return (
            <div>
                <div style={{ width: "100%" }}>
                    <Magnifier src={this.showingImage()} width="100%" height="100%" mgWidth={300} mgHeight={300}
                        zoomFactor={1.2} mgShape=" square" />

                    {this.renderHeadChooser()}

                    <div style={{ display: "flex" }}>
                        {this.lastUpdateText()}
                        <p style={{
                            textAlign: "center",
                            fontWeight: 600,
                            color: "red"
                        }}>{this.state.online == 1 ? "" : "OFFLINE"}</p>
                        <p style={{ flex: 40, textAlign: "right" }}>Next Update: {this.nextUpdateTime()}</p>
                    </div>
                    <div style={{ display: "flex" }}>
                        <p style={{ flex: 40, textAlign: "left" }}>{minsSinceUpdate}</p>
                        <p />
                        <p style={{ flex: 40, textAlign: "right" }}>{minsUntilUpdate}</p>
                    </div>

                    <div style={{ display: "flex" }}>
                        <IconButton icon="cloud_download" title="Download Image"
                            onClick={() => window.open(Util.download(this.showingImage()), "_blank")}
                            className="wide top8" />
                        <IconButton icon="fullscreen" className="wide top8" title="View Image" style={{ marginLeft: 8, marginRight: 8 }}
                            onClick={this.fullScreen} />
                        {/* {this.state.variant == Variant.CAMERA && Util.isAdmin() && !Util.isSubAccount() &&
                            <IconButton icon="autorenew" className="wide top8" title="Request Image"
                                        onClick={() => this.setState({showRequestImage: true})}/>} */}
                    </div>

                    <div style={{ display: "flex" }} className="top8">
                        <p style={{ flex: 1 }}><b>View Historic Images</b></p>
                        <p><b>{this.state.image_count} Images</b></p>
                    </div>
                    <div style={{ display: "flex" }}>
                        <input placeholder="Date to view" style={{ flex: 1 }} className="vl-input" readOnly
                            ref={this.historicDateInput} />
                        <VLButton style={{ marginLeft: 8 }} title="GO" onClick={this.viewHistoric} />
                    </div>
                </div>
            </div>
        );
    };

    createOpts(maps) {
        return {
            zoomControlOptions: {
                position: maps.ControlPosition.RIGHT_CENTER,
                style: maps.ZoomControlStyle.SMALL
            },
            mapTypeControlOptions: {
                position: maps.ControlPosition.TOP_RIGHT
            },
            mapTypeControl: true,
            streetViewControl: true,
            rotateControl: true,
            scaleControl: true,
            mapTypeId: "hybrid"
        };
    }

    loadedMap = ({ map, maps }) => {
        this.map = map;
        if (this.state.sensor_lat) {
            map.panTo({ lat: this.state.sensor_lat, lng: this.state.sensor_long });
        }
    };

    renderNote = note => {
        return <div className="w3-card-4 top16" style={{ padding: 16, background: note.archived ? "#eee" : "white" }}>
            {note.note}
            <div style={{ display: "flex", justifyContent: "space-between" }} className="top8">
                <p className="nomargin" style={{ color: "#888" }}>{note.username}</p>
                <p className="nomargin"
                    style={{ color: "#888" }}>{moment.unix(note.time).format("DD/MM/YY HH:mm")}</p>
                {Util.isAdmin() && !Util.isSubAccount() && note.archived != 1 &&
                    <i className="material-icons hoverable" onClick={() => {
                        this.archiveNote(note.id);
                    }}>archive</i>}
                {note.archived == 1 && <p className="nomargin"><i>Archived</i></p>}
            </div>
        </div>;
    };

    archiveNote = id => {
        this.showTextAlert("Archive Note", "Are you sure you want to archive this note?", "Archive", "Cancel", () => {
            API.POST("systems/archiveNote", { id }, result => {
                if (result.success) {
                    this.load();
                } else {
                    this.basicAlert(result.error);
                }
            });
        }, true);
    };

    toggleShowArchived = () => {
        const showArchived = !this.state.showArchived;
        this.setState({ showArchived });
    };

    notes = () => {
        let archiveToggle = <VLButton className="top16"
            title={(this.state.showArchived ? "Hide" : "Show ") + " archived notes"}
            onClick={this.toggleShowArchived} />;

        let notesTable = <p>No Notes</p>;

        const notes = this.state.notes.filter(e => e.archived == 0 || this.state.showArchived);

        if (notes.length) {
            notesTable = <div style={{ flex: 1, padding: "16px 16px" }}>
                {notes.map(this.renderNote)}
            </div>;
        }
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    height: "calc(100vh - 200px)",
                    overflowY: "auto"
                }}>
                {notesTable}
                <div style={{ width: "100%", padding: 16 }}>
                    <h3>Type a new note</h3>
                    <textarea className="vl-input" style={{ width: "100%", height: 200, resize: "none" }} name="new_note"
                        onChange={this.handleInputChange} value={this.state.new_note} />
                    <VLButton className="top16" title="Add New Note" onClick={this.addNote} />
                    <br />
                    {Util.isAdmin() && !Util.isSubAccount() && archiveToggle}
                </div>
            </div>
        );
    };

    addNote = () => {
        const note = this.state.new_note.trim();
        if (note.length == 0) {
            this.basicAlert("Please enter some note text");
            return;
        }
        const camera_id = this.props.id;

        API.POST("systems/addNote", { note, camera_id }, result => {
            if (result.success) {
                this.load();
                this.setState({ new_note: "" });
            } else {
                this.basicAlert(result.error);
            }
        });
    };

    renderMapColumn = () => {
        const current = this.state.viewing_map;
        let items = [
            <SegmentedControl
                name="viewing_map"
                options={[{ label: "Map", value: 2, default: current === 2 }, {
                    label: "Notes",
                    value: 1,
                    default: current === 1
                }]}
                value={this.state.viewing_map}
                setValue={viewing_map => this.setState({ viewing_map })}
                style={{ color: window.primary, margin: "0 8px 8px 0" }} />
        ];

        if (this.state.viewing_map == 1) {
            items.push(this.notes());
        }

        items.push(
            <div style={{
                width: "100%",
                flex: 1,
                marginTop: 0,
                display: this.state.viewing_map == 2 ? "block" : "none"
            }}>

                <GoogleMapReact ref={this.mapRef}
                    bootstrapURLKeys={{ key: Constants.GOOGLE_MAPS_KEY }}
                    defaultCenter={{
                        lat: this.state.sensor_lat || 51.95,
                        lng: -0.33
                    }}
                    defaultZoom={19}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={this.loadedMap}
                    options={this.createOpts}>

                    <Marker clicked={() => {
                    }} system={this.state} lat={this.state.sensor_lat} lng={this.state.sensor_long} />

                </GoogleMapReact>

            </div>);

        items.push(
            <div style={{
                width: "100%",
                background: "#DDD",
                paddingTop: 16,
                display: this.state.viewing_map == 3 ? "block" : "none"
            }}>

                {this.state.loaded && <TwitterTimelineEmbed
                    sourceType="profile"
                    screenName={this.state.twitter_name}
                    linkColor="#FAB81E"
                    noHeader={true}
                    noFooter={true}
                    options={{ height: document.documentElement.clientHeight - 200 }}
                />}
            </div>);

        return items;
    };

    renderText = () => {
        if (this.state.system_text) {
            let st = {
                borderColor: window.primary,
                borderWidth: 2,
                borderStyle: "solid",
                margin: "16px",
                padding: 16
            };
            return <div style={st}>{this.state.system_text}</div>;
        }
    };

    renderHeadChooser = () => {
        let heads = this.state.sensor_images.map((image, index) => {
            return {
                label: image.tag || "Image " + (index + 1),
                value: index,
                default: index == this.state.viewing_head
            };
        });

        if (heads.length < 2) {
            return;
        }

        return <SegmentedControl
            name="viewing_head"
            options={heads}
            setValue={viewing_head => this.setState({ viewing_head })}
            style={{ width: "100%", color: window.primary }} />;
    };

    cameraType = () => {
        if (this.state.variant == Variant.IP_CAMERA) {
            return "IP Camera";
        } else if (this.state.twin_camera) {
            return "Twin Head";
        } else if (this.state.ptz_system) {
            return "Multi Head";
        }
        return "Single Head";
    };

    renderInfo = () => {
        let enabled = b => b ? " Enabled" : " Disabled";

        let items = [{ name: "Camera Type", value: this.cameraType() }];

        if (!Util.isCommunity()) {
            items = items.concat([
                { name: "Face Obscuring (AFO)", value: enabled(this.state.image_auto_blur) },
                { name: "Car Reg Obscuring (ACO)", value: enabled(this.state.car_reg_blur) },
                { name: "Community View", value: enabled(this.state.community_app_view_en) },
                // {name: "Area", value: this.state.groups[this.state.system_group]}
            ]);
        }

        items.push({ name: "Postcode", value: this.state.sensor_postcode });

        if (!Util.isCommunity()) {
            items = items.concat([
                { name: "Grid Ref", value: this.state.grid_ref },
                { name: "Asset ID", value: this.state.asset_id },
                { name: "What3Words", value: <a target="_blank" href={"https://what3words.com/" + this.state.what3words}>{this.state.what3words}</a> }
            ]);
        }

        if (this.state.variant == Variant.CAMERA) {
            items = items.concat([
                {
                    name: "GSM Signal",
                    value: [Util.isCommunity() ? "" : this.state.gsm_provider, Render.gsmImage(this.state.gsm_signal, "")]
                },
                { name: "Temperature", value: this.state.temperature + "°C" },
                { name: "Solar Panel", value: this.state.camera_solar + " V" },
                { name: "Battery", value: this.state.battery + " V" }
            ]);
        }

        items = items.concat([
            { name: "Update Rate", value: this.state.update + " min" },
            { name: "Distance", value: this.getDistance() }
        ]);

        // if (!Util.isCommunity()) {
        //     items.push({name: "Twitter Handle", value: this.state.twitter_feed || "None"});
        //     const hasInstallDate = this.state.installed > 0;
        //     items.push({name: "Install Date", value: !hasInstallDate ? "Awaiting Commissioning" : moment.unix(this.state.installed).format("DD/MM/YYYY")});
        //     if (this.state.rapid_deployment) {
        //         items.push({name: "GPS", value: this.state.gps_locked ? "Locked" : "Searching"});
        //     }
        //     items.push({name: "Ext. Motion Sensor", value: this.state.ext_motion_sensor_en ? "Enabled" : "Disabled"});
        // }

        items = items.map(f => <tr>
            <th>{f.name}</th>
            <td>{f.value}</td>
        </tr>);

        return (
            <table style={{ marginLeft: 0, width: "calc(100% - 0px)" }} className="w3-table-all">
                <tbody>
                    {items}
                </tbody>
            </table>
        );
    };

    linkedLink = () => {
        if (this.state.hiRes) {
            return "/sensor/" + this.state.sensor_id;
        }
        return "/sensor/" + this.state.linked_id;
    };

    renderButtons = () => {
        let buttons = [{ title: "No Message", icon: "message", disabled: true }];


        let hasLink = (this.state.hiRes || this.state.linked_id > 0);
        buttons.push({
            title: this.state.hiRes ? "High Res Sensor" : "Linked Level Sensor",
            link: hasLink ? this.linkedLink() : null,
            disabled: !hasLink,
            icon: "show_chart"
        });
        if (this.state.variant == Variant.CAMERA && Util.isAdmin() && !Util.isSubAccount()) {
            buttons.push({ title: "Edit Camera", icon: "edit", link: "/edit/" + this.state.sensor_id });
            // Temporarily taken out this function - buttons.push({title: "Enhanced Poll", icon: "speed", onClick: () => this.setState({showRequestEnhanced: true})});
        }

        if (Util.isAdmin() && !Util.isSubAccount()) {
            buttons.push({ title: "Apps Graph", onClick: () => this.setState({ viewing_stats: true }), icon: "bar_chart" });

            buttons.push({ title: "Broadcast", link: "/broadcast/" + this.state.sensor_id, icon: "notifications_active" });
        }

        buttons.push({ title: "Power Graph", icon: "battery_charging_full", onClick: () => this.setState({ showPowerGraph: true }) });

        buttons = buttons.map(b => (
            <IconButton style={{
                margin: 8,
                width: "calc(50% - 16px)",
                disabled: b.disabled
            }} title={b.title} disabled={b.disabled} href={b.link} onClick={b.onClick} icon={b.icon} />
        ));

        return <div style={{ display: "flex", flexWrap: "wrap", marginTop: 16 }}>{buttons}</div>;
    };

    viewHistoric = () => {
        let date = this.state.historic_date;
        if (date == null) {
            //take midnight
            date = moment().startOf("day").unix();
        }
        this.props.navigate("/camera/" + this.state.sensor_id + "/images/" + date);
    };

    fullScreen = () => {
        this.setState({ viewingUrl: this.showingImage() });
    };

    nextUpdateTime = () => {
        return moment.unix(this.state.sensor_comms_unix + this.state.update * 60).format(" HH:mm");
    };

    showingImage = () => {
        let head = this.state.sensor_images[this.state.viewing_head];
        if (head != null) {
            return head.image;
        }
    };

    getDistance = () => {
        let loc1 = { lat: this.state.lat, lng: this.state.lng };
        let loc2 = { lat: this.state.sensor_lat, lng: this.state.sensor_long };
        return Util.round1(Util.getHaversineDistance(loc1, loc2) / 1000) + " km";
    };

}

export default CameraScreen;
